import React from "react";
import classnames from "classnames";
import { useTranslation } from "@helpers/translate";
import { ModalCloseButton } from "../../../components/ModalCloseButton";
import "./TradeDetailsHeader.sass";

/**
 * Coin with its price or name, the trade status and the close button.
 *
 * @param {object} props
 * @param {string} props.titleId id the dialog is labelled by
 * @param {string} props.coin
 * @param {string|null} props.coinIcon
 * @param {string} props.subtitle under the ticker
 * @param {boolean} props.isClosed
 * @param {() => void} props.onClose
 */
export const TradeDetailsHeader = ({
  titleId,
  coin,
  coinIcon,
  subtitle,
  isClosed,
  onClose,
}) => {
  const { __ } = useTranslation();
  const statuses = [
    [false, __("futures.trade_details.opened")],
    [true, __("futures.trade_details.closed")],
  ];

  return (
    <header className="trade-details-header">
      <div className="trade-details-header__coin">
        {coinIcon && (
          <img src={coinIcon} alt="" className="trade-details-header__icon" />
        )}
        <span className="trade-details-header__coin-text">
          <span id={titleId} className="trade-details-header__ticker">
            {coin}
          </span>
          <span className="trade-details-header__subtitle">{subtitle}</span>
        </span>
      </div>

      <div className="trade-details-header__actions">
        {/* Shows the status, not a switch */}
        <div className="trade-details-header__status">
          {statuses.map(([isClosedStatus, label]) => (
            <span
              key={label}
              className={classnames("trade-details-header__status-item", {
                "trade-details-header__status-item--active":
                  isClosedStatus === isClosed,
                "trade-details-header__status-item--open": !isClosedStatus,
              })}
              aria-hidden={isClosedStatus !== isClosed}
            >
              {label}
            </span>
          ))}
        </div>
        <ModalCloseButton
          className="trade-details-header__close"
          onClick={onClose}
          iconSize={20}
        />
      </div>
    </header>
  );
};
